import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const HomeNavIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M5 21C4.44772 21 4 20.5523 4 20V9.5C4 9.18524 4.14819 8.88885 4.4 8.7L11.4 3.45C11.7556 3.18333 12.2444 3.18333 12.6 3.45L19.6 8.7C19.8518 8.88885 20 9.18524 20 9.5V20C20 20.5523 19.5523 21 19 21H15C14.4477 21 14 20.5523 14 20V15C14 14.4477 13.5523 14 13 14H11C10.4477 14 10 14.4477 10 15V20C10 20.5523 9.55228 21 9 21H5Z" />
  </SvgIcon>
);

export default HomeNavIcon;
